import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';

import { useMediaQuery } from 'react-responsive';
import FileService from '../helper/fileHelper';

import styles from './analytics.module.scss';

const analyticsType = (asset) => {
  const type = FileService.fileType(asset.metadata);
  switch (type){
    case "PDF":
    case "PPTX":
    case "PPT":
    case "DOCX":
    case "DOC":
      return "PAGE";
    case "VIDEO":
    case "YOUTUBE":
      return "RANGE";

    default:
      return "DEFAULT";
  }
}

export const AnalyticsDebug = (({ asset, analytics }) => {
  const desktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });

  const [show, setShow] = useState(false);
  const type = analyticsType(asset);

  return (
    <div className={styles.analytics}>
      <button className={styles.action} onClick={() => {
        setShow(!show);
      }}>
        {show ? 'CLOSE' : 'DEBUG'}
      </button>
      {show &&
        <div className={styles.dialog}>
          <div className={styles.body}>
            {type === 'PAGE' &&
              <PageAnalytics analytics={analytics} />
            }

            {type === 'RANGE' &&
              <RangeAnalytics analytics={analytics} />
            }

            {type === "DEFAULT" &&
              <DefaultAnalytics analytics={analytics} />
            }
          </div>
        </div>
      }
    </div>
  );

});

const PageAnalytics = ({ analytics }) => {
  const desktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });

  const pages = _.get(analytics, 'datapoints') || [];

  return (
    <table width={desktop ? 200 : 300}>
      <thead>
        <tr>
          <th className={styles.name}>Page</th>
          <th>Views</th>
          <th>Duration</th>
        </tr>
      </thead>
      <tbody>
        {pages.map((page, index) => {
          return (
            <tr key={page.index}>
              <td className={styles.name} width='50'>{`Page ${page.index}`}</td>
              <td width='50'>{page.views}</td>
              <td width='50'>{_.round(page.duration, 2).toFixed(2)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

const RangeAnalytics = ({ analytics }) => {
  const desktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });

  const formatDuration = (timeSpent) => {
    const value = Math.floor(timeSpent);

    if (timeSpent > 60) {
      var minutes = Math.floor(value / 60);
      var seconds = value % 60;
      return `${FileService.padNumber(minutes, 2)}:${FileService.padNumber(seconds, 2)}`;
    }else{
      return `00:${FileService.padNumber(value, 2)}`;
    }
  }

  return (
    <table width={desktop ? 200 : 300}>
      <thead>
        <tr>
          <th className={styles.name}>Range</th>
        </tr>
      </thead>
      <tbody>
        {(analytics || []).map((range, index) => {
          return (
            <tr key={range.id}>
              <td className={styles.name} width='50'>
                {`Start ${formatDuration(range.start)} - End ${formatDuration(range.end)}`}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

const DefaultAnalytics = ({ analytics }) => {
  const desktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });

  const formatDuration = (timeSpent) => {
    const value = Math.floor(timeSpent);

    if (timeSpent > 60) {
      var minutes = Math.floor(value / 60);
      var seconds = value % 60;
      return `${FileService.padNumber(minutes, 2)}:${FileService.padNumber(seconds, 2)}`;
    }else{
      return `00:${FileService.padNumber(value, 2)}`;
    }
  }

  if(!analytics){
    return <p className={styles.empty}>No Analytics</p>;
  }

  return (
    <table width={desktop ? 200 : 300}>
      <thead>
        <tr>
          <th className={styles.name}>Timespent</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className={styles.name} width='50'>
            {`${formatDuration(analytics.duration)}`}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
